// extracted by mini-css-extract-plugin
export default {"price":"a7-z","priceRow":"b7-z","onSale":"c7-z","msrpLabelPrice":"d7-z","msrpLabel":"e7-z","originalPrice":"f7-z","percentOff":"g7-z"};